import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './Header';
import Footer from './Footer';
import { useTestStore } from '../../store/testStore';

interface LayoutProps {
  children: React.ReactNode;
  showHeaderFooter?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, showHeaderFooter = true }) => {
  const { hasCompletedOnboarding } = useTestStore();
  
  // Only show header and footer if onboarding is completed and showHeaderFooter is true
  const shouldShowHeaderFooter = hasCompletedOnboarding && showHeaderFooter;
  
  return (
    <div className="flex flex-col min-h-screen">
      <AnimatePresence>
        {shouldShowHeaderFooter && (
          <motion.div
            initial={{ y: -100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -100, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <Header />
          </motion.div>
        )}
      </AnimatePresence>
      
      <AnimatePresence mode="wait">
        <motion.main 
          className="flex-grow"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          {children}
        </motion.main>
      </AnimatePresence>
      
      <AnimatePresence>
        {shouldShowHeaderFooter && (
          <motion.div
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 100, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <Footer />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Layout;